import React from "react";
import { compose } from "redux";
import Add from "@material-ui/icons/Add";
import { grey } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Typography, ButtonBase } from "@material-ui/core";

import SortableListRow from "app/components/SortableList/SortableListRow";

const HeliReportAddNewItemRow = ({ classes, onClick }) => (
  <SortableListRow
    noborder
    striped={false}
    onClick={onClick}
    component={ButtonBase}
    classes={{
      root: classes.root,
    }}
  >
    <Grid container justifyContent="center" alignItems="center">
      <Add />
      <Typography variant="caption">Add item</Typography>
    </Grid>
  </SortableListRow>
);

const styles = () => ({
  root: {
    background: grey[100],
    border: `1px dashed ${grey[300]}`,
    cursor: "pointer",
    "&:hover": {
      border: `2px dashed ${grey[300]}`,
    },
    "@media print": {
      display: "none",
    },
  },
});

export default compose(withStyles(styles))(HeliReportAddNewItemRow);
